import React, { useEffect, useState } from "react";
import MainSectionCard from "./MainsectionCard";
import { API_ENDPOINTS, SITE_URL, toAbsoluteUrl } from "../../assets/helpers/AssetHelpers";
import { Categories } from "../../types/types";
import { getCMSCategory } from "../../services/api/Api";
import SkeletonComponent from "../SkeletonComponent";
import MostSearchFaq from "../MostSearchFAQs/MostSearchFaq";
import Circulars from "../Circulars/Circulars";
interface Category {
  new_id: string;
  id: string;
  category_name: string;
  parent_cms_category: string;
}
interface ApiResponse {
  data: {
    all_category: Category[];
  };
}

const MainSection = () => {
  const [cmsCategoryLoading, setCmsCategoryLoading] = useState(true);
  const [data1, setData1] = useState<ApiResponse>({
    data: {
      all_category: [],
    },
  });

  const fetchCMSCategory = async () => {
    try {
      setCmsCategoryLoading(true);
      const response = await getCMSCategory(`site=${SITE_URL}`);
      if (response?.message) {
        setData1(response);
        setCmsCategoryLoading(false);
      }
    } catch (error) {
      console.log("FetchCms Category Error");
    } finally {
      setCmsCategoryLoading(false);
    }
  };

  useEffect(() => {
    fetchCMSCategory();
  }, []);

  const getSubcategories = (parentCategory: any, allCategories: any) => {
    const subcategories = allCategories.filter(
      (category: any) => category.parent_cms_category === parentCategory.id,
    );

    if (subcategories.length === 0) {
      return null;
    }

    return subcategories.map((subcategory: any) => ({
      ...subcategory,
      subcategories: getSubcategories(subcategory, allCategories),
    }));
  };

  const nestedCategories: Omit<Categories, "is_group" | "level" | "sorting_order">[] =
    data1?.data?.all_category
      ?.filter(
        (category) => category.parent_cms_category === null || category.parent_cms_category === "",
      )
      .map((category) => ({
        ...category,
        subcategories: getSubcategories(category, data1?.data?.all_category),
      }));

  return (
    <>
      <section id="main-section">
        <div className="container mb-5 mb-lg-0">
          <div className="row">
            <div className="col my-lg-5">
              <div className="row">
                <div className="col-lg-11 mx-auto mt-5 mt-lg-0 px-4 px-lg-2">
                  <div className="row gx-lg-5">
                    <div className="col-lg-7">
                      <div className="accordion">
                        {cmsCategoryLoading ? (
                          <SkeletonComponent name={"CategoryCard"} />
                        ) : (
                          nestedCategories.map((category, index) => (
                            <MainSectionCard key={category.id} cards={category} index={index} />
                          ))
                        )}
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <MostSearchFaq />
                      <div className="mt-4 border-top border-2 pt-3">
                        <Circulars />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default React.memo(MainSection);
